import * as React from 'react';
import semanticClassNames from '../SearchButton.semanticClassNames';

import StylableButton from '../../StylableButton/viewer/skinComps/StylableButton/StylableButton.skin';

import type { IStylableButtonImperativeActions } from '../../StylableButton/StylableButton.types';
import type { ISearchButtonProps } from '../SearchButton.types';

const SearchButton: React.ForwardRefRenderFunction<
  IStylableButtonImperativeActions,
  ISearchButtonProps
> = ({ isDisabled, customClassNames = [], ...props }, ref) => {
  const onClick = React.useCallback(() => {
    window.alert('Search button clicked');
  }, []);

  return (
    <StylableButton
      {...props}
      onClick={onClick}
      ref={ref}
      semanticClassNames={semanticClassNames}
      customClassNames={customClassNames}
      a11y={{ label: 'Search hard coded label for now' }}
      isDisabled={isDisabled}
    />
  );
};

export default React.forwardRef(SearchButton);
